import { inject, Injectable } from '@angular/core'

import { ApiService } from '@ti/core/api'
import { ForgotPasswordViewModel } from '@ti/shared/auth-ui/models'

@Injectable()
export class AdminForgotPasswordViewModel extends ForgotPasswordViewModel {
  protected readonly api = inject(ApiService)

  protected async requestPasswordReset(email: string) {
    await this.api.ti.user.resetPassword(email)
  }
}
